import { render, staticRenderFns } from "./ModalSuporteAdicionarCaixaCirurgica.vue?vue&type=template&id=b1cc96dc&scoped=true"
import script from "./ModalSuporteAdicionarCaixaCirurgica.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteAdicionarCaixaCirurgica.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteAdicionarCaixaCirurgica.vue?vue&type=style&index=0&id=b1cc96dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cc96dc",
  null
  
)

export default component.exports